import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { createAuthGuard, AuthGuardData } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import {environment} from "../../environments/environment";
import {AllUserRoles} from "../../models/enum/all-user-roles";

// Flatten: realm roles + tutti i client roles in una Set<string>
function flattenGrantedRoles(granted: AuthGuardData['grantedRoles']): Set<string> {
    const all = new Set<string>();
    for (const r of granted.realmRoles) all.add(r);
    for (const roles of Object.values(granted.resourceRoles)) {
        for (const r of roles) all.add(r);
    }
    return all;
}

const isAccessAllowed = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    auth: AuthGuardData
): Promise<boolean> => {
    const kc = inject<Keycloak>(Keycloak as any); // client keycloak-js fornito da provideKeycloak

    // 1) non autenticato → login + stop navigazione
    if (!auth.authenticated) {
        await kc.login({ redirectUri: environment.loginUrl });
        return false;
    }

    // 2) “almeno un ruolo” tra quelli esistenti
    const userRoles = flattenGrantedRoles(auth.grantedRoles);
    const hasAtLeastOne = Object.values(AllUserRoles).some((r) => userRoles.has(r));
    if (!hasAtLeastOne) {
        await kc.logout({ redirectUri: environment.afterLoginRedirect });
        return false;
    }

    // 3) ruoli specifici richiesti dalla route
    const required: string[] | undefined = route.data?.['roles'];
    if (!required || required.length === 0) return true;

    const ok = required.some((r) => userRoles.has(r));
    if (!ok) {
        await kc.logout({ redirectUri: environment.afterLoginRedirect });
    }
    return ok;
};

// Esporta la guard CanActivateFn per il router
export const authGuard: CanActivateFn = createAuthGuard<CanActivateFn>(isAccessAllowed);
